<section class="page-back">
  <!-- start banner Area -->
  <section class="top-banner">
    <div class="top-banner-img" style="">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <h1 style="padding: 30px 0px 0px 0px !important;"> Publier une offre d'emploi</h1>
            <p class="text-white link-nav">
              <a routerLink="/admin" style="color: #ff5a00 !important">Accueil</a> <span
                class="lnr lnr-arrow-right"></span>
              <span> <a routerLink="/admin/publier-offre-emploi" style="color: white;"> Publier une offre
                  d'emploi</a></span>
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
  <br> <br>

  <!-- Start service Area -->
  <section class="service-area section-gap" id="service">
    <!-- Status de l'emploi -->
    <div class="col-md-12 mb-5 text-center">
      <h5 class="mb-1">Status : </h5> <span class="badge badge-primary" *ngIf="jobEditing.getStatus() == 'En cours'">En
        cours d'édition</span> <span class="badge badge-warning"
        *ngIf="jobEditing.getStatus() == 'En attente de validation'">En attente de validation</span> <span
        class="badge badge-success" *ngIf="jobEditing.getStatus() == 'Validé'">Offre publiée</span>
    </div>
    <div class="container">
      <div class="card mb-3 pr-5 pl-5"
        style=" box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);">
        <div class="card-body" id="depot-cv">
          <div class="row">
            <div class=" col-md-12">
              <h3 class="mt-3 mb-4" style="text-align: center; font-weight: bold;">Informations sur l'offre
              </h3>

              <form [formGroup]="jobForm" (ngSubmit)="onSubmitJobForm()">
                <div class="row">
                  <div class="form-group col-md-4">
                    <label for="reference">Référence</label>
                    <input type="text" class="form-control" id="reference" [value]="reference" disabled>
                  </div>
                  <div class="form-group col-md-4">
                    <label for="company">Société <span class="star-style">**</span></label>
                    <div class="input-group">
                      <select class="form-control" id="company" formControlName="company_id">
                        <option value="">Selectionner...</option>
                        <option *ngFor="let company of companyList" value="{{ company.getId() }}">{{ company.getName()
                          }}
                        </option>
                      </select>
                      <div class="input-group-prepend">
                        <a href="admin/ajouter-entreprises" class="btn btn-info" target="_blank">Nouv.</a>
                      </div>
                    </div>
                  </div>
                  <div class="form-group col-md-4">
                    <label for="areaActivity">Secteur d'activité <span class="star-style">**</span></label>
                    <div class="input-group">
                      <select class="form-control" id="areaActivity" formControlName="area_activity_id">
                        <option value="">Selectionner...</option>
                        <option *ngFor="let areaActivity of areaActivityList" value="{{ areaActivity.getId() }}">{{
                          areaActivity.getLibelle() }}</option>
                      </select>
                      <div class="input-group-prepend">
                        <span class="input-group-text btn-prepend" (click)="addNewAreaActivity()">Nouv.</span>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4 mb-3">
                    <label for="profession">Profession <span class="star-style">**</span></label>
                    <div class="input-group">
                      <select class="form-control" id="profession" formControlName="profession_id">
                        <option value="">Selectionner...</option>
                        <option *ngFor="let profession of professionList" value="{{ profession.getId() }}">{{
                          profession.getLibelle() }}</option>
                      </select>
                      <div class="input-group-prepend">
                        <span class="input-group-text btn-prepend" (click)="addNewProfession()">Nouv.</span>
                      </div>
                    </div>
                  </div>
                  <div class="form-group col-md-4">
                    <label for="libelle">Libelle<span class="star-style">**</span></label>
                    <input type="text" class="form-control h-40px" id="libelle" formControlName="libelle">
                  </div>
                  <div class="form-group col-md-4">
                    <label for="typeJob">Type d'emploi<span class="star-style">**</span></label>
                    <select class="form-control" id="typeJob" formControlName="type_job">
                      <option value="">Selectionner...</option>
                      <option value="Temps plein">Temps plein</option>
                      <option value="Temps partiel">Temps partiel</option>
                      <option value="Intérim">Intérim</option>
                      <option value="Stage">Stage</option>
                    </select>
                  </div>

                  <div class="form-group col-md-4">
                    <label for="country">Pays<span class="star-style">**</span></label>
                    <select class="form-control" id="country" formControlName="country"
                      (ngModelChange)="onChangeCountry($event)">
                      <option [value]="country" *ngFor="let country of countryList">{{ country }}</option>
                    </select>
                  </div>
                  <div class="form-group col-md-4">
                    <label for="city">Ville<span class="star-style">**</span></label>
                    <select class="form-control" id="city" formControlName="city">
                      <option [value]="city" *ngFor="let city of cityList">{{ city }}</option>
                    </select>
                  </div>
                  <div class="form-group col-md-4">
                    <label for="expirationDate">Expire le, <span class="star-style">**</span></label>
                    <input type="date" class="form-control h-40px" id="expirationDate"
                      formControlName="expiration_date">
                  </div>

                  <div class="form-group col-md-4"
                    [ngClass]="jobDescribeValue == null ? 'form-group col-md-4' : 'form-group col-md-4'">
                    <label for="idcard">Description emploi<span style="font-size: 10px; font-weight: 700;">(pdf, <
                          1Mo)</span>
                    </label>
                    <span class="btn btn-success w-100" *ngIf="jobDescribeValue == null"
                      (click)="chooseNewJobDescribeFile()">Joindre
                      fichier</span>
                    <span class="btn btn-success w-100" *ngIf="jobDescribeValue != null"
                      (click)="chooseNewJobDescribeFile()">Remplacer
                      fichier</span>
                    <span *ngIf="jobDescribeFile != null" style="font-size: 10px; font-weight: 700; color: green">
                      Super!
                      Fichier
                      joint</span>
                  </div>
                  <div *ngIf="jobDescribeValue !== undefined" class="form-group col-md-4 my-auto pt-3">
                    <a [href]="jobDescribe" target="_blank" class="btn btn-info w-100"
                      *ngIf="jobDescribeValue !== undefined">Afficher description</a>
                  </div>
                  <div class="form-group col-md-8">
                    <label for="description">Description <span class="star-style">**</span></label>
                    <textarea class="form-control h-40px" id="description" row="4"
                      formControlName="description"></textarea>
                  </div>
                </div>

                <h3 class="mt-3 mb-4" style="text-align: center; font-weight: bold;">Profil recrutement
                </h3>
                <div class="row">
                  <div class="form-group col-md-4">
                    <label for="years_of_experience">Année d'exp. <span class="star-style">**</span></label>
                    <select class="form-control" id="years_of_experience" formControlName="years_of_experience">
                      <option value="">Selectionner...</option>
                      <option value="Sans experience">Sans experience</option>
                      <option value="Moins d'un an">Moins d'un an</option>
                      <option value="1 à 2ans">1 à 2ans</option>
                      <option value="3 à 5ans">3 à 5ans</option>
                      <option value="6 à 10ans">6 à 10ans</option>
                      <option value="Plus de 10ans">Plus de 10ans</option>
                    </select>
                  </div>
                  <div class="form-group col-md-4">
                    <label for="">Note accordée (Année Exp)<span class="star-style"></span></label>
                    <input type="number" min="1" class="form-control h-40px" id="" formControlName="years_exp_rating">
                  </div>

                  <div class="form-group col-md-4">
                    <label for="mINAge">Age Minimum<span class="star-style"></span></label>
                    <input type="number" min="10" class="form-control h-40px" id="minAge" formControlName="min_age">
                  </div>
                  <div class="form-group col-md-4">
                    <label for="maxAge">Age Maximum<span class="star-style"></span></label>
                    <input type="number" min="18" class="form-control h-40px" id="maxAge" formControlName="max_age">
                  </div>
                  <div class="form-group col-md-4">
                    <label for="maxAge">Note accordée (Age) <span class="star-style"></span></label>
                    <input type="number" min="1" class="form-control h-40px" id="" formControlName="age_rating">
                  </div>
                  <div class="form-group col-md-4">
                    <label for="typeJob">Etape du processus<span class="star-style">**</span></label>
                    <select class="form-control" id="typeJob" formControlName="job_level">
                      <option value="1" selected>Collecte</option>
                      <option value="2">Pré sélection</option>
                      <option value="3">Tests</option>
                      <option value="4">Entretiens</option>
                      <option value="5">Dépôt de rapport</option>
                      <option value="6">Cloture</option>
                    </select>
                  </div>
                </div>
                <button type="submit" class="primary-btn text-white" [disabled]="jobForm.invalid"
                  *ngIf="!jobIsLoading">Enregister</button>
                <p class="text-danger" style="padding-top: 15px; margin-left: 15px;" *ngIf="jobIsLoading">Veuillez
                  patienter...</p>

              </form>

            </div>
          </div>
        </div>
      </div>
      <div class="card mb-3 pr-5 pl-5"
        style=" box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);">
        <div class="card-body" id="depot-cv">
          <div class="row">
            <div class=" col-md-6">
              <fieldset class="form-area fieldset-panel">
                <legend class="legend-style" style="width: 65%;">Formations requises </legend>
                <form [formGroup]="jobTrainingForm" (ngSubmit)="onSubmitJobTrainingForm()">
                  <div class="row">
                    <div class="form-group col-md-6">
                      <label for="training">Formation requise <span class="star-style">**</span></label>
                      <div class="input-group">
                        <select class="form-control" id="training" formControlName="training_id">
                          <option value="">Selectionner...</option>
                          <option value="{{ training.getId() }}" *ngFor="let training of trainingList">{{
                            training.getLibelle()
                            }}</option>
                        </select>
                        <div class="input-group-prepend">
                          <span class="input-group-text btn-prepend" style="    height: 40px; margin-top: 5px;"
                            (click)="addNewTraining()">Nouv.</span>
                        </div>
                      </div>
                    </div>
                    <div class="form-group col-md-6">
                      <label for="levelTraining">Niveau d'étude requis <span class="star-style">**</span></label>
                      <select class="form-control" id="levelTraining" formControlName="level_of_study">
                        <option value="">Selectionner...</option>
                        <option value="Secondaire">Secondaire</option>
                        <option value="Terminal">Terminal</option>
                        <option value="Formation professionnelle">Formation professionnelle</option>
                        <option value="Baccalauréat">Baccalauréat</option>
                        <option value="Universitaire sans diplôme">Universitaire sans diplôme</option>
                        <option value="BAC + 2">BAC + 2</option>
                        <option value="Licence(BAC + 3)">Licence(BAC + 3)</option>
                        <option value="Master 1(BAC + 4)">Master 1(BAC + 4)</option>
                        <option value="Master 2(BAC + 5)">Master 2(BAC + 5)</option>
                        <option value="Doctorat(BAC + 7)">Doctorat(BAC + 7)</option>
                      </select>
                    </div>
                    <div class="form-group col-md-6">
                      <label for="rating_training">Note accordée</label>
                      <input type="number" min="1" class="form-control h-40px" id="rating_training"
                        formControlName="rating">
                    </div>
                    <div class="form-group col-md-6">
                      <button type="submit" style="margin-top: 35px;" class="primary-btn text-white"
                        [disabled]="jobTrainingForm.invalid" *ngIf="!jobTrainingIsLoading">Ajouter</button>
                      <p class="text-danger" style="padding-top: 15px; margin-left: 15px;" *ngIf="jobTrainingIsLoading">
                        Veuillez
                        patienter...</p>
                    </div>

                  </div>
                </form>
              </fieldset>
            </div>
            <div class=" col-md-6">
              <!-- Liste des ajouts -->
              <div class="form-group mt-5" style="width: 100%; overflow: auto;">
                <table class="table table-bordered">
                  <tr>
                    <th>Formations</th>
                    <th>Niveau d'étude</th>
                    <th>Note</th>

                    <th>Action</th>
                  </tr>
                  <tr *ngFor="let jobTraining of jobTrainingList">
                    <td>{{ jobTraining['trainings']['libelle'] }}</td>
                    <td>{{ jobTraining['levelOfStudy'] }}</td>
                    <td>{{ jobTraining['rating'] }}</td>

                    <td>

                      <span class="btn btn-danger a-btn-slide-text" (click)="removeJobTraining(jobTraining['id'])">
                        <span class="glyphicon glyphicon-remove" aria-hidden="true"><svg
                            xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                            class="bi bi-trash" viewBox="0 0 16 16">
                            <path
                              d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z" />
                            <path fill-rule="evenodd"
                              d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z" />
                          </svg></span>
                      </span>
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="card  mb-3 pr-5 pl-5"
        style=" box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);">
        <div class="card-body" id="depot-cv">
          <div class="row">
            <div class=" col-md-6">
              <fieldset class="form-area fieldset-panel">
                <legend class="legend-style" style="width: 75%;">Connaissances lingustiques </legend>
                <form [formGroup]="jobLanguageForm" (ngSubmit)="onSubmitJobLanguageForm()">
                  <div class="row">
                    <div class="form-group col-md-6">
                      <label for="language">Langues <span class="star-style">**</span></label>
                      <div class="input-group">
                        <select class="form-control" id="language" formControlName="language_id">
                          <option value="">Selectionner...</option>
                          <option value="{{ language.getId() }}" *ngFor="let language of languageList">{{
                            language.getLibelle()
                            }}</option>
                        </select>
                        <div class="input-group-prepend">
                          <span class="input-group-text btn-prepend" (click)="addNewLanguage()">Nouv.</span>
                        </div>
                      </div>
                    </div>
                    <div class="form-group col-md-6">
                      <label for="levelLanguage">Niveau de maitrise <span class="star-style">**</span></label>
                      <select class="form-control" id="levelLanguage" formControlName="level">
                        <option value="">Selectionner...</option>
                        <option value="Débutant">Débutant</option>
                        <option value="Intermédiaire">Intermédiaire</option>
                        <option value="Excellente maitrise">Excellente maitrise</option>
                      </select>
                    </div>
                    <div class="form-group col-md-6">
                      <label for="rating_langue">Note accordée</label>
                      <input type="number" min="1" class="form-control h-40px" id="rating_langue"
                        formControlName="rating">
                    </div>
                    <div class="col-md-6">
                      <button type="submit" style="margin-top: 35px;" class="primary-btn text-white"
                        [disabled]="jobLanguageForm.invalid" *ngIf="!jobLanguageIsLoading">Ajouter</button>
                      <p class="text-danger" style="padding-top: 15px; margin-left: 15px;" *ngIf="jobLanguageIsLoading">
                        Veuillez
                        patienter...</p>
                    </div>
                  </div>
                </form>
              </fieldset>
            </div>
            <div class=" col-md-6">
              <!-- Liste des ajouts -->
              <div class="form-group mt-5" style="width: 100%; overflow: auto;">
                <table class="table table-bordered">
                  <tr>
                    <th>Langues</th>
                    <th>Niveau</th>
                    <th>Note</th>
                    <th>Action</th>
                  </tr>
                  <tr *ngFor="let jobLanguage of jobLanguageList">
                    <td>{{ jobLanguage['languages']['libelle'] }}</td>
                    <td>{{ jobLanguage['level'] }}</td>
                    <td>{{ jobLanguage['rating'] }}</td>
                    <td>
                      <span class="btn btn-danger a-btn-slide-text" (click)="removeJobLanguage(jobLanguage['id'])">
                        <span class="glyphicon glyphicon-remove" aria-hidden="true"><svg
                            xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                            class="bi bi-trash" viewBox="0 0 16 16">
                            <path
                              d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z" />
                            <path fill-rule="evenodd"
                              d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z" />
                          </svg></span>
                      </span>


                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="card pr-5 pl-5"
        style=" box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);">
        <div class="card-body" id="depot-cv">
          <div class="row">
            <div class=" col-md-6">
              <fieldset class="form-area fieldset-panel">
                <legend class="legend-style" style="width: 75%;">Connaissances informatique </legend>
                <form [formGroup]="jobSkillForm" (ngSubmit)="onSubmitJobSkillForm()">
                  <div class="row">
                    <div class="form-group col-md-6">
                      <label for="skill">Compétences <span class="star-style">**</span></label>
                      <div class="input-group">
                        <select class="form-control" id="skill" formControlName="skill_id">
                          <option value="">Selectionner...</option>
                          <option value="{{ skill.getId() }}" *ngFor="let skill of skillList">{{ skill.getLibelle() }}
                          </option>
                        </select>
                        <div class="input-group-prepend">
                          <span class="input-group-text btn-prepend" (click)="addNewSkill()">Nouv.</span>
                        </div>
                      </div>
                    </div>
                    <div class="form-group col-md-6">
                      <label for="skillLevel">Niveau de maitrise <span class="star-style">**</span></label>
                      <select class="form-control" id="skillLevel" formControlName="level">
                        <option value="">Selectionner...</option>
                        <option value="Débutant">Débutant</option>
                        <option value="Intermédiaire">Intermédiaire</option>
                        <option value="Excellente maitrise">Excellente maitrise</option>
                      </select>
                    </div>
                    <div class="form-group col-md-6">
                      <label for="rating_skill">Note accordée</label>
                      <input type="number" min="1" class="form-control h-40px" id="rating_skill"
                        formControlName="rating">
                    </div>
                    <div class="col-md-6">
                      <button type="submit" style="margin-top: 35px;" class="primary-btn text-white"
                        [disabled]="jobSkillForm.invalid" *ngIf="!jobSkillIsLoading">Ajouter</button>
                      <p class="text-danger" style="padding-top: 15px; margin-left: 15px;" *ngIf="jobSkillIsLoading">
                        Veuillez
                        patienter...</p>
                    </div>
                  </div>
                </form>
              </fieldset>
            </div>
            <div class=" col-md-6">
              <!-- Liste des ajouts -->
              <div class="form-group mt-5" style="width: 100%; overflow: auto;">
                <table class="table table-bordered">
                  <tr>
                    <th>Logiciels</th>
                    <th>Niveau</th>
                    <th>Note</th>
                    <th>Action</th>
                  </tr>
                  <tr *ngFor="let jobSkill of jobSkillList">
                    <td>{{ jobSkill['skills']['libelle'] }}</td>
                    <td>{{ jobSkill['level'] }}</td>
                    <td>{{ jobSkill['rating'] }}</td>
                    <td>
                      <span class="btn btn-danger a-btn-slide-text" (click)="removeJobSkill(jobSkill['id'])">
                        <span class="glyphicon glyphicon-remove" aria-hidden="true"><svg
                            xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                            class="bi bi-trash" viewBox="0 0 16 16">
                            <path
                              d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z" />
                            <path fill-rule="evenodd"
                              d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z" />
                          </svg></span>
                      </span>

                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row mt-5 pb-40">
        <!-- Button poster -->
        <div class="col-md-12 mb-5 text-center">
          <button type="button" (click)="publishJob()" class="primary-btn btn-post-offer"
            *ngIf="jobEditing.getStatus() != 'Validé'" style="color: white !important;">Publier l'offre</button>
        </div>
      </div>
    </div>
  </section>
</section>
<!-- End service Area -->